import { render, staticRenderFns } from "./CustomersWithNoRecentSales.vue?vue&type=template&id=7623a04e&scoped=true"
import script from "./CustomersWithNoRecentSales.vue?vue&type=script&lang=js"
export * from "./CustomersWithNoRecentSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7623a04e",
  null
  
)

export default component.exports